//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {
    
    //Use strict mode
    'use strict';

    /**
     * @class am.AddressSearchBarView
     * Widget allowing for a specific address to be searched for. This widget inherits from base 
     * class L.Control and is defined following the recommendations of the Leaflet web site (see 
     * http://leafletjs.com/examples/extending/extending-3-controls.html).
     */
    module.AddressSearchBarView = L.Control.extend({
        // Private attributes
        _formElementPromise: undefined, // Promise which will resolve to the form's DOM element when the widget is completely loaded
        _inputFieldPromise: undefined,  // Promise which will resolve to the input field's DOM element when the widget is completely loaded

        /**
         * Class constructor
         * @constructor
         *
         * @param {Object} options - Same options as for class L.Control
         */
        initialize: function(options) {
            // Call parent constructor
            L.Control.prototype.initialize.call(this, options);

            this._config = options;

            // Initialize the private properties
            this._formElementPromise = am.utils.controllablePromise();
            this._inputFieldPromise  = am.utils.controllablePromise();
        },

        /**
         * Function called when adding the widget to the map.
         *
         * @param {L.Map} map - Leaflet map in which the widget should be added
         * @return {HTMLElement} - DOM element corresponding to the widget
         */
        onAdd: function(map) {
            // Create the widget
            var container = L.DomUtil.create('div', 'am-widget');
            var _this = this;
            am.templateManager.fillElementWithTemplate(container, 'address-search-field', {}, function($container) {
                var $inputField  = $container.find('#am-address-search-field');
                var $formElement = $inputField.closest('.am-address-search-widget');

                if(
                    _this._config && _this._config._other &&
                    _this._config._other.hasOwnProperty("isPrivate") && 
                    _this._config._other.isPrivate &&
                    _this._config._other.hasOwnProperty("searchBarMargin")
                ){
                    $container.attr('style', 'margin-top: ' + _this._config._other.searchBarMargin + ' !important');
                }
            
                $inputField.focus(function(){
                    _this.expandSearchField();
                }).blur(function(){
                    if (!$formElement.is(':hover')) {
                        _this.collapseSearchField();
                    }
                });

                $formElement.hover(undefined, function () {
                    if (!$inputField.is(':focus')) {
                        _this.collapseSearchField();
                    }
                });

                _this._formElementPromise.resolve($formElement.get(0));
                _this._inputFieldPromise.resolve($inputField.get(0));
            });

            // Prevent interacting with the map when clicking on the widget
            am.utils.preventMapInteractionOverElement(container);

            return container;
        },

        /**
         * Function called when removing the widget from the map.
         *
         * @param {L.Map} map - Leaflet map from which the widget should be removed
         */
        onRemove: function(map) {
            // Restore interaction with the map
            am.utils.restoreMapInteractionOverElement(this._container);
        },

        /**
         * Expands the search field to half the screen's size
         */
        expandSearchField: function() {
            this._inputFieldPromise.then(function(inputField) {
                $(inputField).closest('.am-address-search-widget').addClass('am-field-expanded');
                am.eventManager.trigger('address_search_field_expanded');
            });
        },

        /** 
         * Restores the width of the search field to its original value. This function cancels the effect of 
         * am.view.AddressSearchBar#expandSearchField.
         */
        collapseSearchField: function() {
            this._inputFieldPromise.then(function(inputField) {
                $(inputField).closest('.am-address-search-widget').removeClass('am-field-expanded');
                am.eventManager.trigger('address_search_field_collapsed');
            });
        },

        /**
         * Hides the search field to its original value. This function cancels the effect of
         * am.view.AddressSearchBar#showSearchField.
         */
        hideSearchField: function() {
            var _this = this;
            this._inputFieldPromise.then(function(inputField) {
                $(_this.getContainer()).addClass('hidden');
            });
        },

        /**
         * Displays the search field to its original value. This function cancels the effect of
         * am.view.AddressSearchBar#hideSearchField.
         */
        showSearchField: function() {
            var _this = this;
            this._inputFieldPromise.then(function(inputField) {
                $(_this.getContainer()).removeClass('hidden');
            });
        },

        /**
         * Clears the contents of the search field
         */
        clearSearchField: function() {
            this._inputFieldPromise.then(function(inputField) {
                inputField.value = "";
            });
            $('#am-address-clear-button').closest('.input-group-btn').addClass('hidden');
            am.eventManager.trigger('address_search_field_cleared');
        },

        /**
         * Returns the top-level DOM element of the widget
         *
         * @return {DOMElement} - Highest-level DOM element of the widget
         */ 
        getContainer: function() {
            return this._container;
        },

        /**
         * Returns the DOM element corresponding to the form. Note that the returned value is actually a Promise which 
         * evaluates to the form's DOM element when the widget is entirely loaded.
         *
         * @return {Promise} - Promise evaluating to the DOM element corresponding to the form
         */
        getForm: function() {
            return this._formElementPromise;
        },

        /**
         * Returns the DOM element corresponding to the address search field. Note that the returned value is actually
         * a Promise which evaluates to the address search field's DOM element when the widget is entirely loaded.
         *
         * @return {Promise} - Promise evaluating to the DOM element corresponding to the address search field
         */ 
        getInputField: function() {
            return this._inputFieldPromise;
        },

    });

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Factory function returning an instance of am.AddressSearchBarView
     * 
     * @param {Object} options - Same options as for class L.Control
     * @return {am.AddressSearchBarView} - New instance of class am.AddressSearchBarView
     */
    module.addressSearchBarView = function(options) {
        return new am.AddressSearchBarView(options);
    };

    return module;

})(am.utils || {});